module.exports = "<form>\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\">Stop Application</h4>\n    </div>\n    <div class=\"modal-body\">\n        You are about to STOP the application proccess. This action is irreversible. Do you want to proceed?\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.edit()\">Stop Application</button>\n        <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button>\n    </div>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tickets/templates/confirm.stop.application.modal.html
// module id = 661
// module chunks = 0